var map = {
	"./DefaultLocationCoverImage.png": "d186",
	"./LoginBackground.png": "7660",
	"./LogoGlovo.png": "961f",
	"./logo_activecampaign.png": "57df",
	"./logo_cabify.png": "c1c0",
	"./logo_closerlogistics.png": "de82",
	"./logo_cloudbeds.png": "33ee",
	"./logo_covermanager.png": "b1eb",
	"./logo_deelivers.png": "e3c8",
	"./logo_deliveroo.png": "b0e6",
	"./logo_flipdish.png": "540c",
	"./logo_flyt.png": "afa9",
	"./logo_freshkds.png": "5ff7",
	"./logo_gloriafood.png": "0f6c",
	"./logo_glovo.png": "b98f",
	"./logo_glovob2b.png": "71ae",
	"./logo_glovoscrapper.png": "2c84",
	"./logo_googlebookings.png": "2138",
	"./logo_gstock.png": "36bf",
	"./logo_holded.png": "6a67",
	"./logo_kassensichv.png": "2460",
	"./logo_mox.png": "3985",
	"./logo_paack.png": "24be",
	"./logo_prestashop.png": "a0ee",
	"./logo_shargo.png": "9ac7",
	"./logo_shipday.png": "2f97",
	"./logo_shopify.png": "ae2a",
	"./logo_squarespace.png": "b76d",
	"./logo_stuart.png": "d936",
	"./logo_thefork.png": "90d1",
	"./logo_uber.png": "02e5",
	"./logo_uberdirect.png": "c429",
	"./logo_ueat.png": "4d61",
	"./logo_woocommerce.png": "efee",
	"./lottie/lottie-bar-loading": "764d",
	"./lottie/lottie-bar-loading.json": "764d",
	"./lottie/lottie-generateQR": "8350",
	"./lottie/lottie-generateQR.json": "8350",
	"./lottie/lottie-spinner-loading": "c2bb",
	"./lottie/lottie-spinner-loading.json": "c2bb",
	"./lottie/lottie-success": "3b7e",
	"./lottie/lottie-success.json": "3b7e",
	"./svg/ad.svg": "c622",
	"./svg/ae.svg": "eec2",
	"./svg/af.svg": "6526",
	"./svg/ag.svg": "d365",
	"./svg/al.svg": "ce07",
	"./svg/alarm.svg": "ef78",
	"./svg/alert.svg": "6db1",
	"./svg/allergens/celery.svg": "d999",
	"./svg/allergens/crustaceans.svg": "ad85",
	"./svg/allergens/eggs.svg": "4a51",
	"./svg/allergens/fish.svg": "f22f",
	"./svg/allergens/gluten.svg": "f22d",
	"./svg/allergens/lupin.svg": "f4b3",
	"./svg/allergens/milk.svg": "8cc6",
	"./svg/allergens/molluscs.svg": "44f7",
	"./svg/allergens/mustard.svg": "cfd5",
	"./svg/allergens/peanuts.svg": "0190",
	"./svg/allergens/sesame.svg": "6804",
	"./svg/allergens/soy.svg": "a02a",
	"./svg/allergens/sulfites.svg": "2609",
	"./svg/allergens/tree-nuts.svg": "5daf",
	"./svg/am.svg": "205e",
	"./svg/ao.svg": "89d7",
	"./svg/apple-pay.svg": "a18f",
	"./svg/apply-all.svg": "d243",
	"./svg/ar.svg": "3129",
	"./svg/arrow-down-2.svg": "46ea",
	"./svg/arrow-down.svg": "1f02",
	"./svg/arrow-left.svg": "fe87",
	"./svg/arrow-right.svg": "e8c5",
	"./svg/arrow-up.svg": "8dec",
	"./svg/at.svg": "98a0",
	"./svg/au.svg": "f56c",
	"./svg/aw.svg": "f238",
	"./svg/az.svg": "2589",
	"./svg/ba.svg": "989a",
	"./svg/back-arrow.svg": "42a7",
	"./svg/bb.svg": "ae4f",
	"./svg/bd.svg": "a7dc",
	"./svg/be.svg": "8f24",
	"./svg/bell-slash.svg": "1f48",
	"./svg/bell.svg": "08fc",
	"./svg/bf.svg": "675c",
	"./svg/bg.svg": "6fe2",
	"./svg/bh.svg": "253a",
	"./svg/bi.svg": "6ee7",
	"./svg/bike.svg": "a159",
	"./svg/bizum.svg": "c51a1",
	"./svg/bj.svg": "2a7e",
	"./svg/bn.svg": "932e",
	"./svg/bo.svg": "fed1",
	"./svg/br.svg": "154e",
	"./svg/brands.svg": "a843",
	"./svg/bs.svg": "03e8",
	"./svg/bt.svg": "56b9",
	"./svg/burger.svg": "49f5",
	"./svg/bv.svg": "cd80",
	"./svg/bw.svg": "9f266",
	"./svg/by.svg": "6254",
	"./svg/bz.svg": "c1bb",
	"./svg/ca.svg": "4ea5",
	"./svg/calculator.svg": "6b52",
	"./svg/calendar-red.svg": "08ee",
	"./svg/calendar.svg": "c08a",
	"./svg/card.svg": "c9ad",
	"./svg/cart.svg": "2ffe",
	"./svg/cash.svg": "dfab",
	"./svg/cat.svg": "206b",
	"./svg/catalog.svg": "3867",
	"./svg/cf.svg": "b6e0",
	"./svg/cg.svg": "b96f",
	"./svg/ch.svg": "57e2",
	"./svg/chain.svg": "9afc",
	"./svg/chat.svg": "d385",
	"./svg/check-circle.svg": "999e",
	"./svg/check.svg": "f4d6",
	"./svg/cl.svg": "9504",
	"./svg/clean.svg": "c206",
	"./svg/clock-counter-clockwise.svg": "efe8",
	"./svg/clock-wise.svg": "6389",
	"./svg/clock.svg": "8c51",
	"./svg/close-store.svg": "97ff",
	"./svg/close.svg": "7a38",
	"./svg/cm.svg": "0a5e",
	"./svg/cn.svg": "7130",
	"./svg/co.svg": "e6e8",
	"./svg/contract.svg": "577c",
	"./svg/copies.svg": "7248",
	"./svg/cr.svg": "c6d2",
	"./svg/cross-eye.svg": "4f48",
	"./svg/cu.svg": "d869",
	"./svg/currencies/dollar.svg": "a690",
	"./svg/currencies/euro.svg": "b488",
	"./svg/currencies/pound.svg": "8b1f",
	"./svg/cy.svg": "1df2",
	"./svg/cz.svg": "5d3d",
	"./svg/danger.svg": "308f",
	"./svg/de.svg": "82d3",
	"./svg/default-notification.svg": "7ae2",
	"./svg/delete-arrow.svg": "2701",
	"./svg/delivery.svg": "b48a",
	"./svg/device.svg": "7417",
	"./svg/diners.svg": "ef52",
	"./svg/discount.svg": "fcb5",
	"./svg/dizzy-robot-dark.svg": "bd99",
	"./svg/dizzy-robot.svg": "1cdd",
	"./svg/dj.svg": "146a",
	"./svg/dk.svg": "1c31",
	"./svg/dm.svg": "b32f",
	"./svg/do.svg": "eaa6",
	"./svg/done.svg": "7a90",
	"./svg/dots.svg": "d482",
	"./svg/download.svg": "2c2b",
	"./svg/drag.svg": "eefa",
	"./svg/dropdown-menu.svg": "e07b",
	"./svg/duplicate.svg": "8f8f",
	"./svg/dz.svg": "d9f5",
	"./svg/ec.svg": "0973",
	"./svg/ee.svg": "6658",
	"./svg/eg.svg": "2038",
	"./svg/empanadish.svg": "3fbc",
	"./svg/empty-case-dark.svg": "ec03",
	"./svg/empty-case.svg": "7070",
	"./svg/empty.svg": "3770",
	"./svg/en.svg": "c389",
	"./svg/end-shift.svg": "773e",
	"./svg/er.svg": "021a",
	"./svg/error.svg": "8d78",
	"./svg/es.svg": "b3ab",
	"./svg/et.svg": "45e7",
	"./svg/euro.svg": "23e9",
	"./svg/expand.svg": "ea4a",
	"./svg/export.svg": "f796",
	"./svg/external.svg": "c5d0",
	"./svg/eye-closed.svg": "623e",
	"./svg/eye-disabled.svg": "8dc0",
	"./svg/eye.svg": "8c2a",
	"./svg/fi.svg": "f5d9",
	"./svg/file.svg": "a2b8",
	"./svg/filters.svg": "0af8",
	"./svg/fj.svg": "528c",
	"./svg/flag.svg": "b9b1",
	"./svg/floorplan.svg": "9959",
	"./svg/forward.svg": "ca8d",
	"./svg/fr.svg": "d980",
	"./svg/ga.svg": "0b09",
	"./svg/gb.svg": "a9dc",
	"./svg/gd.svg": "8e6d",
	"./svg/ge.svg": "836b",
	"./svg/gh.svg": "1bb8",
	"./svg/gm.svg": "b2aa",
	"./svg/gn.svg": "1c6d",
	"./svg/google-pay.svg": "ef8c",
	"./svg/gq.svg": "f18e",
	"./svg/gr.svg": "515b",
	"./svg/gt.svg": "cca8",
	"./svg/gw.svg": "238e",
	"./svg/gy.svg": "1995",
	"./svg/handle.svg": "8885",
	"./svg/headset.svg": "ac8e",
	"./svg/help.svg": "387d",
	"./svg/history.svg": "571d",
	"./svg/hk.svg": "9342",
	"./svg/hn.svg": "0c0b",
	"./svg/home.svg": "f8e1",
	"./svg/hr.svg": "5566",
	"./svg/ht.svg": "e61a",
	"./svg/hu.svg": "8986",
	"./svg/id.svg": "4d91",
	"./svg/idle-clock.svg": "3b29",
	"./svg/ie.svg": "fff3",
	"./svg/il.svg": "771d",
	"./svg/import.svg": "7179",
	"./svg/important-round.svg": "c7c0",
	"./svg/in-out.svg": "dc39",
	"./svg/in.svg": "3ed2",
	"./svg/info.svg": "f33e",
	"./svg/integration.svg": "afa2",
	"./svg/iq.svg": "bf88",
	"./svg/is.svg": "79d5",
	"./svg/it.svg": "f11c",
	"./svg/izettle.svg": "4654",
	"./svg/jm.svg": "10bc",
	"./svg/jo.svg": "d69b",
	"./svg/jp.svg": "448d",
	"./svg/ke.svg": "834b",
	"./svg/kg.svg": "422c",
	"./svg/kh.svg": "6cc5",
	"./svg/ki.svg": "8e94",
	"./svg/kitchen.svg": "c3ee",
	"./svg/km.svg": "0336",
	"./svg/kp.svg": "b1a2",
	"./svg/kr.svg": "e481",
	"./svg/kw.svg": "5a9b",
	"./svg/kz.svg": "dcce",
	"./svg/lb.svg": "3162",
	"./svg/lc.svg": "b9b0",
	"./svg/li.svg": "5fb0",
	"./svg/line-menu.svg": "920f",
	"./svg/link-break.svg": "6811",
	"./svg/list.svg": "a1c6",
	"./svg/lk.svg": "0491",
	"./svg/loading-error.svg": "f0c6",
	"./svg/loading-spinner.svg": "cca4",
	"./svg/loading.svg": "0621",
	"./svg/location.svg": "c4be",
	"./svg/lock.svg": "5879",
	"./svg/login-logo.svg": "deb0",
	"./svg/logo.svg": "b8d2",
	"./svg/logout.svg": "2ca3",
	"./svg/lr.svg": "bc36",
	"./svg/ls.svg": "5ba1",
	"./svg/lt.svg": "6893",
	"./svg/lu.svg": "4c2a",
	"./svg/lv.svg": "3b9b",
	"./svg/ly.svg": "ad41",
	"./svg/ma.svg": "5039",
	"./svg/mail.svg": "cf6a",
	"./svg/man.svg": "ac90",
	"./svg/map.svg": "5222",
	"./svg/mc.svg": "c417",
	"./svg/md.svg": "525d",
	"./svg/me.svg": "3190",
	"./svg/menu-hamburguer.svg": "288a",
	"./svg/merge.svg": "a7f4",
	"./svg/mg.svg": "7e62",
	"./svg/mh.svg": "4e57",
	"./svg/minus.svg": "225f",
	"./svg/mk.svg": "1371",
	"./svg/ml.svg": "9e22",
	"./svg/mm.svg": "9b20",
	"./svg/mn.svg": "fa12",
	"./svg/mr.svg": "90ec",
	"./svg/mt.svg": "3ce9",
	"./svg/mu.svg": "dc09",
	"./svg/mute.svg": "e69c",
	"./svg/mv.svg": "68d5",
	"./svg/mw.svg": "838a",
	"./svg/mx.svg": "cab7",
	"./svg/my.svg": "f922",
	"./svg/mz.svg": "e589",
	"./svg/na.svg": "7929",
	"./svg/ne.svg": "94eb",
	"./svg/new.svg": "4a97",
	"./svg/ng.svg": "f6fa",
	"./svg/ni.svg": "6ba2",
	"./svg/nl.svg": "3788",
	"./svg/no.svg": "d971",
	"./svg/nobookings.svg": "e4f6",
	"./svg/np.svg": "9582",
	"./svg/nr.svg": "a7b4",
	"./svg/nz.svg": "3016",
	"./svg/om.svg": "4c58",
	"./svg/order.svg": "e403",
	"./svg/organization.svg": "4879",
	"./svg/pa.svg": "52cb",
	"./svg/paint.svg": "73cf",
	"./svg/payment-ticket.svg": "cf3e",
	"./svg/pe.svg": "e790",
	"./svg/pen.svg": "dff0",
	"./svg/pending-payment.svg": "49a3",
	"./svg/people.svg": "2824",
	"./svg/percentage.svg": "eca7",
	"./svg/pg.svg": "d5b3",
	"./svg/ph.svg": "7f7d",
	"./svg/phone.svg": "8623",
	"./svg/pk.svg": "fd23",
	"./svg/pl.svg": "af17",
	"./svg/plus.svg": "0005",
	"./svg/porcentaje.svg": "9e45",
	"./svg/power.svg": "318a",
	"./svg/printer.svg": "a995",
	"./svg/product-specs/glutenfree.svg": "5f15",
	"./svg/product-specs/hot.svg": "d947",
	"./svg/product-specs/medium.svg": "db2d",
	"./svg/product-specs/mild.svg": "feef",
	"./svg/product-specs/vegan.svg": "0687",
	"./svg/product-specs/vegetarian.svg": "f52d",
	"./svg/product.svg": "3221",
	"./svg/products-icon.svg": "a288",
	"./svg/prohibit.svg": "680e",
	"./svg/pt.svg": "919f",
	"./svg/pw.svg": "06f8",
	"./svg/py.svg": "8a31",
	"./svg/qa.svg": "57e5",
	"./svg/qr.svg": "2553",
	"./svg/question.svg": "ad1b",
	"./svg/reports.svg": "af21",
	"./svg/reservas.svg": "bf08",
	"./svg/reuse.svg": "c054",
	"./svg/ro.svg": "5631",
	"./svg/rotar.svg": "92e0",
	"./svg/rs.svg": "7bd9",
	"./svg/ru.svg": "5fec",
	"./svg/rw.svg": "ebd1",
	"./svg/sa.svg": "b755",
	"./svg/sb.svg": "5e9c",
	"./svg/sc.svg": "eb3e",
	"./svg/screen.svg": "adfc",
	"./svg/sd.svg": "d83a",
	"./svg/se.svg": "d8c3",
	"./svg/search.svg": "4b20",
	"./svg/select-all.svg": "ed1d",
	"./svg/settings.svg": "4db7",
	"./svg/sg.svg": "73d8",
	"./svg/shop.svg": "99ef",
	"./svg/si.svg": "26c6",
	"./svg/sk.svg": "f88e",
	"./svg/sl.svg": "1c0d",
	"./svg/sm.svg": "e796",
	"./svg/small-arrow-right.svg": "9238",
	"./svg/sn.svg": "8e39",
	"./svg/so.svg": "76be",
	"./svg/square-menu.svg": "cefb",
	"./svg/sr.svg": "51df",
	"./svg/ss.svg": "a0de",
	"./svg/st.svg": "edc8",
	"./svg/star.svg": "66e8",
	"./svg/store.svg": "77c7",
	"./svg/sunday-logo.svg": "2fce",
	"./svg/super-tip.svg": "12bf",
	"./svg/support.svg": "84d1",
	"./svg/sv.svg": "15c7",
	"./svg/sy.svg": "a622",
	"./svg/sync.svg": "40fb",
	"./svg/sz.svg": "2626",
	"./svg/tabs.svg": "6395",
	"./svg/take-away-small.svg": "a0a9",
	"./svg/take-away.svg": "6018",
	"./svg/td.svg": "f4f5",
	"./svg/tg.svg": "10b8",
	"./svg/th.svg": "b17c",
	"./svg/ticket.svg": "3b81",
	"./svg/till.svg": "7e7d",
	"./svg/time.svg": "34c0",
	"./svg/tip.svg": "cc7f",
	"./svg/tj.svg": "0f15",
	"./svg/tl.svg": "a7d0",
	"./svg/tm.svg": "9619",
	"./svg/tn.svg": "19f1",
	"./svg/to.svg": "8ff0",
	"./svg/tr.svg": "f751",
	"./svg/trash.svg": "ae84",
	"./svg/tt.svg": "9438",
	"./svg/turn-off.svg": "4ace",
	"./svg/tv.svg": "f21a",
	"./svg/tz.svg": "8cf8",
	"./svg/ua.svg": "394e",
	"./svg/ug.svg": "bbcc",
	"./svg/union.svg": "cacb",
	"./svg/upload.svg": "4aa7",
	"./svg/us.svg": "3589",
	"./svg/user.svg": "6739",
	"./svg/uy.svg": "e0a5",
	"./svg/uz.svg": "c16d",
	"./svg/validate.svg": "ac83",
	"./svg/ve.svg": "f382",
	"./svg/vn.svg": "4771",
	"./svg/warning-dark.svg": "2420",
	"./svg/warning.svg": "c7af",
	"./svg/ws.svg": "461c",
	"./svg/ye.svg": "5587",
	"./svg/za.svg": "4c45",
	"./svg/zm.svg": "a10d",
	"./svg/zoom.svg": "6457",
	"./svg/zw.svg": "e109"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ea0";